import { ComponentType } from 'react';
import {
  AutocompleteInput as RaAutocompleteInput,
  BooleanInput as RaBooleanInput,
  DateInput as RaDateInput,
  DateTimeInput as RaDateTimeInput,
  SelectInput as RaSelectInput,
  RadioButtonGroupInput as RaRadioButtonGroupInput,
  TextInput as RaTextInput,
  ReferenceInput as RaReferenceInput,
  NumberInput as RaNumberInput,
  ImageInput as RaImageInput,
  SelectArrayInput as RaSelectArrayInput,
  ArrayInput as RaArrayInput,
  AutocompleteArrayInput as RaAutocompleteArrayInput,
  ReferenceArrayInput as RaReferenceArrayInput,
} from 'react-admin';
import { FieldType } from '../config/types/field';
import UrlInput from '../components/UrlInput';
import RangeInput from '../components/RangeInput';
import PhoneInput from '../components/PhoneInput';
import TranslatedTextInput from '../components/TranslatedTextInput';
import WysiwygInput from '../components/WysiwygInput';
import CountryInput from '../components/CountryInput';
import TagInput from '../components/TagInput';
import LocationInput from '../components/LocationInput';
import FileInput from '../components/FileInput';
import ReferenceArrayInput from '../components/ReferenceArrayInput';
import MonthYearFilterInput from '../components/MonthYearFilter/component';
import SelectChoiceInput from '../components/SelectChoiceInput/SelectChoiceInput';
import DependentBooleanInput from '../components/DependentBooleanInput/dependentBooleanInput';
export default class InputFactory {
  private static inputMap: Record<FieldType, ComponentType<any>> = {
    array: RaArrayInput,
    autocomplete: RaAutocompleteInput,
    autocompleteArray: RaAutocompleteArrayInput,
    boolean: RaBooleanInput,
    buttons: () => null,
    company: RaAutocompleteInput,
    country: CountryInput,
    date: RaDateInput,
    dateTime: RaDateTimeInput,
    dateRange: RaDateInput,
    dependentBoolean: DependentBooleanInput,
    email: RaTextInput,
    file: FileInput,
    frontOfficeLink: () => null,
    image: RaImageInput,
    location: LocationInput,
    multipleSelect: RaSelectArrayInput,
    number: RaNumberInput,
    phone: PhoneInput,
    radio: RaRadioButtonGroupInput,
    range: RangeInput,
    reference: RaReferenceInput,
    referenceArray: ReferenceArrayInput,
    resourceLink: () => null,
    select: RaSelectInput,
    tag: TagInput,
    text: RaTextInput,
    translatedText: TranslatedTextInput,
    url: UrlInput,
    wysiwyg: WysiwygInput,
    monthyearFilter: MonthYearFilterInput,
    selectChoice: SelectChoiceInput,
    recommendation: () => null,
  };

  static getInputComponent<T extends FieldType>(type: T): ComponentType<any> {
    if (type in InputFactory.inputMap) {
      return InputFactory.inputMap[type];
    }
    throw new Error(`Input type ${type} does not exist`);
  }
}
